import { Component } from './component.js';

/**
 * @extends {Component}
 */
class BackButton extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#updateButtonState();
  }

  /**
   * @param {Event} event
   */
  handleBackClick = (event) => {
    event.preventDefault();

    if (this.#hasNavigationHistory()) {
      window.history.back();
    } else {
      const homeUrl = this.dataset.homeUrl || '/';
      window.location.href = homeUrl;
    }
  };

  #hasNavigationHistory() {
    const hasHistoryEntries = window.history.length > 1;
    const hasReferrer = !!document.referrer;
    const isInternalReferrer = hasReferrer && this.#isInternalURL(document.referrer);
    const hasPreviousNavigation = !!sessionStorage.getItem('has-navigated');

    return hasHistoryEntries && (isInternalReferrer || hasPreviousNavigation);
  }

  /**
   * @param {string} url
   * @returns {boolean}
   */
  #isInternalURL(url) {
    try {
      const urlObject = new URL(url);
      return urlObject.origin === window.location.origin;
    } catch {
      return false;
    }
  }

  #updateButtonState() {
    const hasHistory = this.#hasNavigationHistory();
    this.dataset.navigationMode = hasHistory ? 'back' : 'home';
  }
}

window.addEventListener('pageshow', () => {
  sessionStorage.setItem('has-navigated', 'true');
});

if (!customElements.get('back-button')) {
  customElements.define('back-button', BackButton);
}
